import Description from "./description";
import Quantity from "./quantity";

export {
    Description,
    Quantity,
}